// Registry of per-tab components for the Assignment Pipeline.
//
// Tabs are flow-specific: the same state ("passed", "pending", ...) can
// need different content depending on the flow's state_machine_key (see
// GET /assignments/:id/flow-statuses — that's where state_machine_key and
// each status's `status` value come from). So every tab component is
// registered under BOTH identifiers together, never just one — a lookup
// always needs "this state, for this flow", not "this state" in the
// abstract. Mirrors ../actions/actionRegistry.js exactly, one level up.
//
// Each tab file in this folder should call `registerTab` once, e.g.:
//
//   import { registerTab } from './tabRegistry';
//   import PassedTab from './PassedTab';
//
//   registerTab({
//     stateMachineKey: 'default',
//     state: 'passed',
//     component: PassedTab,
//   });
//
// ...and be imported (for its registration side effect) from ./index.js.

const registry = new Map();

const registryKey = (stateMachineKey, state) => `${stateMachineKey}::${state}`;

export const registerTab = ({ stateMachineKey, state, component }) => {
  if (!stateMachineKey || !state) {
    throw new Error('registerTab requires both stateMachineKey and state');
  }
  registry.set(registryKey(stateMachineKey, state), component);
};

// Returns the registered component for this flow + state, or undefined if
// nothing's registered yet — callers should fall back to a generic tab
// renderer rather than treat this as an error, since not every state needs
// bespoke content.
export const getTabComponent = (stateMachineKey, state) =>
  registry.get(registryKey(stateMachineKey, state));
